/**
 * Internal dependencies
 */
import vd from 'lib/vd';
import * as actions from 'state/action-types';

export default (layoutId) => (dispatch) => {
	return vd
		.layout(layoutId)
		.remove()
		.then((layout) => {
			dispatch({ type: actions.DELETE_DASHBOARD_LAYOUT_SUCCESS, payload: { layoutId } });
		});
};
